<template>
  <div class="fab-container">
    <button type="button" class="btn btn_style fab" @click="clickBtn('instagram')">
      <img src="/img/image/icon/ig.png" class="icon" loading="lazy" alt="instagram"/>
    </button>
    <button type="button" class="btn btn_style fab" @click="clickBtn('facebook')">
      <img src="/img/image/icon/fb.png" class="icon" loading="lazy" alt="facebook"/>
    </button>
    <button type="button" class="btn btn_style fab" @click="clickBtn('line')">
      <img src="/img/image/icon/line.png" class="icon" loading="lazy" alt="Line"/>
    </button>
    <button type="button" class="btn btn_style fab" @click="clickBtn('query')">
      <img src="/img/image/icon/query.png" class="icon" loading="lazy" alt="查詢"/>
    </button>
    <button type="button" class="btn btn_style fab" @click="clickBtn('buy')">
      <img src="/img/image/icon/order.png" class="icon" loading="lazy" alt="訂購"/>
    </button>
    <button type="button" class="btn btn_style fab" @click="clickBtn('join')">
      <img src="/img/image/icon/join.png" class="icon" loading="lazy" alt="加盟"/>
    </button>
    <button type="button" class="btn btn_style fab" @click="clickBtn('top')">
      <img src="/img/image/icon/arrow_top.png" class="icon" loading="lazy" alt/>
    </button>
  </div>
</template>

<script>
import {isEmpty} from "../util/helpers";

export default {
  name: "FabWidget",
  computed: {
    settingData() {
      return this.$store.getters.getSettingData;
    },
    instagramUrl() {
      let val = this.settingData.data.url_instagram;
      return isEmpty(val) ? '' : val;
    },
    lineUrl() {
      let val = this.settingData.data.url_line;
      return isEmpty(val) ? '' : val;
    },
    facebookUrl() {
      let val = this.settingData.data.url_facebook;
      return isEmpty(val) ? '' : val;
    },
  },
  methods: {
    clickBtn(type) {
      console.log("type", type);
      switch (type) {
        case 'instagram':
          window.open(this.instagramUrl, '_blank');
          return;
        case 'facebook':
          window.open(this.facebookUrl, '_blank');
          return;
        case 'line':
          window.open(this.lineUrl, '_blank');
          return;
        case 'query':
          this.$router.push({path: '/search'});
          return;
        case 'buy':
          this.$router.push({path: '/buy', query: {state: "create"}});
          return;
        case 'join':
          this.$router.push({path: '/join'});
          return;
        case 'top':
          window.scrollTo({
            top: 0,
            behavior: 'smooth' // 平滑滚动
          });
          return;
      }
    },
  },
}
</script>

<style lang="scss" scoped>

.fab-container {
  position: fixed;
  bottom: 150px;
  right: 50px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
  z-index: 1000; /* 确保按钮浮动在其他内容之上 */
}

@media (max-height: 600px) {
  .fab-container {
    gap: 15px;
  }
}

@media (max-height: 576px) {
  .fab-container {
    gap: 10px;
  }
}

@media (max-width: 576px) {
  .fab-container {
    right: 0;
  }
}


.fab {
  border-radius: 50%; /* 圆形按钮 */
  align-items: center; /* 垂直居中 */
  justify-content: center; /* 水平居中 */
  cursor: pointer; /* 鼠标移到按钮上时显示手形光标 */

}

.btn_style {
  padding: 0;
  margin: 0 0.5rem 0 0 !important;
  border-radius: 50%;
}

.btn_style {
  width: 60px;
  height: 60px
}

@media (max-width: 600px) {
  .btn_style {
    width: 50px;
    height: 50px;
  }
}

@media (max-width: 576px) {
  .btn_style {
    width: 40px;
    height: 40px;
  }
}


.icon {
  width: 60px;
  height: 60px
}

@media (max-width: 600px) {
  .icon {
    width: 50px;
    height: 50px;
  }
}

@media (max-width: 576px) {
  .icon {
    width: 40px;
    height: 40px;
  }
}

</style>
